import { Control, FieldValues, Path } from 'react-hook-form';
import { CreateGpsIntegrationCommandGpsProvider } from '@area-restrita/api-client/model/createGpsIntegrationCommandGpsProvider';
import { cn } from '@/lib/utils';
import { Input } from '@/components/ui/input';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';

import { getProviderFields } from './gpsProviderConfigs';

interface GpsConfigFieldsProps<T extends FieldValues> {
  control: Control<T>;
  provider: CreateGpsIntegrationCommandGpsProvider;
  configFieldName: Path<T>;
}

const GpsConfigFields = <T extends FieldValues>({
  control,
  provider,
  configFieldName,
}: GpsConfigFieldsProps<T>) => {
  const fields = getProviderFields(provider);

  return (
    <>
      {fields.map((dinamicField) => (
        <FormField
          key={dinamicField.key}
          control={control}
          name={`${configFieldName}.${dinamicField.key}` as Path<T>}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{dinamicField.label}</FormLabel>
              <FormControl>
                <Input
                  placeholder={dinamicField.placeholder}
                  type={dinamicField.type || 'text'}
                  {...field}
                  readOnly={dinamicField.readOnly}
                  className={cn({ 'bg-muted': dinamicField.readOnly })}
                />
              </FormControl>
              <FormMessage />
              {dinamicField.helpText && (
                <p className="text-sm text-muted-foreground">
                  {dinamicField.helpText}
                </p>
              )}
            </FormItem>
          )}
        />
      ))}
    </>
  );
};

export default GpsConfigFields;
